import React, { ReactNode } from "react"
import Head from "next/head"
import { useCheck } from "../../hooks/useUser"
import { DefaultSiteName } from "../../libs/vars/system"
import { useRouter } from "next/router"

type Props = {
  children?: ReactNode
  title?: string
}

export default function LayoutMain({ children, title = "" }: Props) {
  // here we just check if user is already logged in and redirect to profile
  useCheck({ isNeedRedirect: true })

  const router = useRouter()
  if (!router?.isReady) return null

  return (
    <>
      <Head>
        <title>
          {title ? title + " | " + DefaultSiteName : DefaultSiteName}
        </title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>

      <div className="min-h-full">{children}</div>
    </>
  )
}
